import type { FlipperFeatureFlagsSchema } from '@libs/data-access/entities'
import { useQuery } from '@tanstack/react-query'

import { queryClientOptions } from '../../../../provider'
import type { ApiErrorResponse, UseAppQueryOptions } from '../../../../types'
import { fetchFlipperFeatureFlags } from '../featureFlags.api'
import { featureFlagsCacheKeys } from '../featureFlags.cacheKeys'

export const useFetchFlipperFeatureFlagsByAccount = (
  queryOptions?: UseAppQueryOptions<
    FlipperFeatureFlagsSchema,
    ApiErrorResponse,
    FlipperFeatureFlagsSchema
  >
) =>
  useQuery<
    FlipperFeatureFlagsSchema,
    ApiErrorResponse,
    FlipperFeatureFlagsSchema
  >({
    ...queryOptions,
    staleTime: queryClientOptions.time.STATIC,
    queryKey: featureFlagsCacheKeys.action.flipper.getByAccountId(),
    queryFn: () => fetchFlipperFeatureFlags()
  })
